import { render, staticRenderFns } from "./ImageNews.vue?vue&type=template&id=7d4276fb&scoped=true"
import script from "./ImageNews.vue?vue&type=script&lang=js"
export * from "./ImageNews.vue?vue&type=script&lang=js"
import style0 from "./ImageNews.vue?vue&type=style&index=0&id=7d4276fb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4276fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4276fb')) {
      api.createRecord('7d4276fb', component.options)
    } else {
      api.reload('7d4276fb', component.options)
    }
    module.hot.accept("./ImageNews.vue?vue&type=template&id=7d4276fb&scoped=true", function () {
      api.rerender('7d4276fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/ImageNews.vue"
export default component.exports